/**
 * This saga takes in all events, despatches the appropriate action to be picked by other sagas,
 * and add the event to the events list
 */
import { takeEvery, select, put } from "redux-saga/effects"
import { ADD_PUSHER_BID_EVENT, SET_BIDS } from '../actionTypes.js'
import { getBids, getBidsFilter } from "../rootReducer.js"


const addBid = (bids, bid) => {
    const newBids = (bids || []).filter(b => b.id !== bid.id)
    newBids.unshift(bid)
    return newBids
}
const removeBid = (bids, bid)  => (bids || []).filter(b => b.id !== bid.id)
const removeLoadBids = (bids, load) => (bids || []).filter(b => b.load_id !== load.id)

const bidMatchesFilter = (filter, bid) => {
    let match = filter.live_bids

    if (match) {
        match = (bid.void === false)
    }

    if (match && bid.hasOwnProperty('actual_bid')) {
        match = bid.actual_bid
    } else if (match) {
        match = bid.actual_bid_id === null
    }

    if (match && filter.user) {
        match = (filter.user.value === bid.user_id) || (filter.user.value === bid.load.sale_rep_id)
    }
    
    if (match && filter.bid_status) {
        match = ((filter.bid_status === 'ALL') || (filter.bid_status === bid.status))
    }

    if (match && filter.load_type === 'OPEN') {
        match = (filter.load_type === bid.load.status)
    }


    return match
}

// WORKERS
function* workerBidEvent(action) {
    const evt = action.data
    let bid = null
    let load = null
    let filter = null
    switch (evt.event_type) {
        case 'LOAD':
            load = evt.subject
            if (load.status !== 'OPEN') {
                const bids = yield select(getBids)
                const newBids = removeLoadBids(bids, load)
                yield put({type: SET_BIDS, bids: newBids})
            }
            break
        case 'BID':
            filter = yield select(getBidsFilter)
            // TODO: Check if bid matches the filter
            //Also this should be where we try to determine if we are going to add or remove the bid
            bid = evt.subject

            const bids = yield select(getBids)
            // console.log('bid event', bid)
            if (bidMatchesFilter(filter, bid)) {
                const newBids = addBid(bids, bid)
                // update age on bids
                yield put({type: SET_BIDS, bids: newBids})
            } else {
                const newBids = removeBid(bids, bid)
                yield put({type: SET_BIDS, bids: newBids})
            }
            break
        default:
            break
    }

}

// WATCHERS
export function* watchBidEventSaga() {
    yield takeEvery(ADD_PUSHER_BID_EVENT, workerBidEvent)
}

